import styled from 'styled-components';

import { PayerType } from '../shared/DischargeCalendarPatientCard';

interface MonthViewAggregateCardProps {
  count: number;
  payerType: PayerType;
}

export default function MonthViewAggregateCard({ count, payerType }: MonthViewAggregateCardProps) {
  const label = payerType === 'medicare' ? 'Medicare' : 'Other';

  return (
    <Card $payerType={payerType}>
      {count} {label}
    </Card>
  );
}

const Card = styled.div<{ $payerType: PayerType }>`
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  background-color: ${({ $payerType, theme }) =>
    $payerType === 'medicare' ? theme.colors.accentGreen10 : 'rgba(64, 159, 242, 0.1)'};

  border-left: 3px solid
    ${({ $payerType, theme }) => ($payerType === 'medicare' ? theme.colors.accentGreen : theme.colors.pictonBlue)};
`;
